import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const deleteTask = ({ churchId, taskId }) => {
  return axios.delete(`/churches/${churchId}/tasks/${taskId}`);
};

export const useDeleteTask = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("tasks");
      setNotification({
        type: "success",
        message: "Task deleted successfully!"
      });
    },
    ...config,
    mutationFn: deleteTask
  });
};
